/* eslint-disable camelcase */
import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  SvgIcon,
} from '@mui/material';
import OrderItem from 'types/OrderItem';
import isNonProduction from 'utilities/isNonProduction';
// eslint-disable-next-line camelcase
import { Luci_Shopping_Api_Models_OrderItem } from 'types/api/v7.1/models/Luci_Shopping_Api_Models_OrderItem';
import { Luci_Shopping_Api_Models_ImageWithVariants } from 'types/api/v7.1/models/Luci_Shopping_Api_Models_ImageWithVariants';
import ProductLineItem from '../ProductLineItem';

export default function ProductAccordion({
  lineItem,
}: {
  lineItem: OrderItem;
}): JSX.Element {
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <Accordion
      sx={(muiTheme) => ({
        backgroundColor: muiTheme.palette.systemSurface.surf4,
        flex: '1 1 auto',
        margin: '0',
      })}
      expanded={expanded === 'panel'}
      onChange={handleChange('panel')}
    >
      <AccordionSummary
        sx={(muiTheme) => ({
          '& .MuiAccordionSummary-content': {
            backgroundColor: muiTheme.palette.background.paper,
          },
        })}
        expandIcon={
          <SvgIcon>
            <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
          </SvgIcon>
        }
        aria-controls="panel-content"
        id="panel-header"
      >
        <ProductLineItem
          id={parseInt(lineItem.itemNumberRetailerAssigned ?? '', 10) ?? undefined}
          image={
            (lineItem?.image as Luci_Shopping_Api_Models_ImageWithVariants) ??
            'https://shop.paparazzipremiere.com/static/media/inventory_image_1024x1024.fdc7147ba9120b8ad3af.png'
          }
          description={lineItem.description ?? ''}
          name={lineItem.name ?? ''}
          sku={lineItem.sku ?? ''}
          quantity={lineItem.quantity || 0}
          salePrice={lineItem?.salePrice ?? 0}
          isFree={lineItem?.isFree ?? false}
          isReward={lineItem?.isReward ?? false}
          type={Luci_Shopping_Api_Models_OrderItem.type.BUNDLE}
        />
      </AccordionSummary>
      <AccordionDetails>
        {lineItem?.children?.map((item: OrderItem) => (
          <div key={`${item.id}-${item.sku}`}>
            {isNonProduction && (
              <>
                <Chip
                  label={`DEV ONLY: Reward value for ${
                    (item?.quantity ?? 0) > 0
                      ? (item?.quantity ?? 0) * (item?.rewardPointValue ?? 0)
                      : item?.rewardPointValue ?? 0
                  }`}
                  sx={{ fontWeight: 'bold' }}
                />
                <br />
              </>
            )}
            <ProductLineItem
              id={parseInt(item.itemNumberRetailerAssigned ?? '', 10) ?? undefined}
              image={item.image ?? undefined}
              description={item.description ?? ''}
              name={item.name ?? ''}
              sku={item.sku ?? ''}
              quantity={item.quantity || 1}
              isFree={item.isFree || false}
              isReward={item.isReward || false}
              salePrice={item?.salePrice ?? 0}
              type={Luci_Shopping_Api_Models_OrderItem.type.PRODUCT}
            />
          </div>
        ))}
      </AccordionDetails>
    </Accordion>
  );
}
